export default "__VITE_ASSET__B40bhSaP__"